/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TrainingFrequency = 'DAILY' | 'WEEKLY' | 'BI_WEEKLY' | 'MONTHLY';

export const TrainingFrequency = {
    Daily: 'DAILY' as TrainingFrequency,
    Weekly: 'WEEKLY' as TrainingFrequency,
    BiWeekly: 'BI_WEEKLY' as TrainingFrequency,
    Monthly: 'MONTHLY' as TrainingFrequency
};

